import { render, staticRenderFns } from "./OrderFromGenericElement.vue?vue&type=template&id=0dbbb56e"
import script from "./OrderFromGenericElement.vue?vue&type=script&lang=js"
export * from "./OrderFromGenericElement.vue?vue&type=script&lang=js"
import style0 from "./OrderFromGenericElement.vue?vue&type=style&index=0&id=0dbbb56e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports